import { History } from 'lucide-react';
import { GopherGlyph } from './GopherGlyph';
import { useTranslation } from 'react-i18next';
import { TeeIconButton } from '@/components/ui/tee-icon-button';
import { useAssistant } from '@/contexts/AssistantContext';

/** 56px collapsed rail with Assistant and History buttons (D-14). */
export function AssistantRail() {
  const { t } = useTranslation();
  const { unread, expandFromRail, showHistory } = useAssistant();

  return (
    <div className="flex h-full w-14 flex-col items-center gap-2 border-l border-[var(--border-default)] bg-[var(--background-page-content)] pt-2">
      <div className="relative">
        <TeeIconButton
          aria-label={t('assistant.rail.assistant')}
          icon={<GopherGlyph size={20} />}
          onClick={expandFromRail}
          className="h-10 w-10 rounded-[8px] bg-[var(--background-badge-green)] text-[var(--color-forest)]"
        />
        {unread && (
          <span
            data-testid="assistant-unread-dot"
            className="pointer-events-none absolute right-1 top-1 h-2 w-2 rounded-full bg-[var(--color-gold-500)] ring-2 ring-[var(--background-page-body)]"
          >
            <span className="sr-only">{t('assistant.panel.unread')}</span>
          </span>
        )}
      </div>
      <TeeIconButton
        aria-label={t('assistant.rail.history')}
        icon={<History size={20} />}
        onClick={() => {
          expandFromRail();
          showHistory();
        }}
        className="h-10 w-10 rounded-[8px]"
      />
    </div>
  );
}
